module.exports.InviteRestrictValues = InviteRestrictValues = {
  MANAGED: 'managed'
  MANAGED_OR_DOMAIN: 'managed-or-domain'
  DOMAIN: 'domain'
}



// WEBPACK FOOTER //
// ./app/scripts/views/organization/constants.coffee